export default {
  common: {
    welcome: 'Bienvenido',
    loading: 'Cargando...',
    save: 'Guardar',
    cancel: 'Cancelar',
    delete: 'Eliminar',
    edit: 'Editar',
    search: 'Buscar...',
    filter: 'Filtrar',
    export: 'Exportar',
    refresh: 'Actualizar',
    back: 'Volver',
    next: 'Siguiente',
    previous: 'Anterior',
    confirm: 'Confirmar',
    yes: 'Sí',
    no: 'No',
    close: 'Cerrar',
    actions: 'Acciones',
    status: 'Estado',
    active: 'Activo',
    inactive: 'Inactivo',
    enabled: 'Habilitado',
    disabled: 'Deshabilitado',
    success: 'Éxito',
    error: 'Error',
    warning: 'Advertencia',
    info: 'Información',
    apply: 'Aplicar',
    download: 'Descargar',
    upload: 'Subir',
    view: 'Ver',
    details: 'Detalles',
    name: 'Nombre',
    email: 'Correo electrónico',
    phone: 'Teléfono',
    address: 'Dirección',
    country: 'País',
    city: 'Ciudad',
    state: 'Estado',
    zipCode: 'Código postal',
    createdAt: 'Creado el',
    updatedAt: 'Actualizado el',
    description: 'Descripción',
    type: 'Tipo',
    amount: 'Monto',
    date: 'Fecha',
    time: 'Hora',
    from: 'Desde',
    to: 'Hasta',
    all: 'Todos',
    none: 'Ninguno',
    select: 'Seleccionar',
    selected: 'Seleccionado',
    total: 'Total',
    subtotal: 'Subtotal',
    pending: 'Pendiente',
    approved: 'Aprobado',
    rejected: 'Rechazado',
    completed: 'Completado',
    failed: 'Fallido',
    processing: 'Procesando',
    cancelled: 'Cancelado',
    required: 'Requerido',
    optional: 'Opcional',
    today: 'Hoy',
    yesterday: 'Ayer',
    thisWeek: 'Esta semana',
    thisMonth: 'Este mes',
    lastMonth: 'Mes pasado',
    custom: 'Personalizado',
    range: 'Rango',
    noData: 'No hay datos disponibles',
    noResults: 'No se encontraron resultados',
    showMore: 'Mostrar más',
    showLess: 'Mostrar menos',
    expand: 'Expandir',
    collapse: 'Contraer',
    clearAll: 'Limpiar todo',
    selectAll: 'Seleccionar todo',
    deselectAll: 'Deseleccionar todo',
    copyToClipboard: 'Copiar al portapapeles',
    copied: '¡Copiado!',
    notAvailable: 'N/D',
    upgrade: 'Actualizar',
  },
  auth: {
    login: 'Iniciar sesión',
    logout: 'Cerrar sesión',
    email: 'Correo electrónico',
    password: 'Contraseña',
    rememberMe: 'Recordarme',
    forgotPassword: '¿Olvidaste tu contraseña?',
    signIn: 'Entrar',
    signUp: 'Registrarse',
    loginSuccess: 'Sesión iniciada correctamente',
    loginError: 'Correo o contraseña inválidos',
    sessionExpired: 'Sesión expirada. Por favor inicia sesión de nuevo.',
    adminPanel: 'Panel de administración',
    needHelp: '¿Necesitas ayuda?',
    poweredBy: 'Desarrollado por',
  },
  nav: {
    dashboard: 'Panel de control',
    instruments: 'Instrumentos',
    clients: 'Clientes',
    accounts: 'Cuentas',
    trading: 'Trading',
    reports: 'Reportes',
    auditLog: 'Registro de auditoría',
    withdrawals: 'Retiros',
    deposits: 'Depósitos',
    settings: 'Configuración',
    plugins: 'Plugins',
    accountGroups: 'Grupos de cuentas',
    kyc: 'KYC',
    apiDocs: 'Docs API',
    notifications: 'Notificaciones',
    upgrade: 'Actualizar',
    groupPricing: 'Precios de grupo',
  },
  dashboard: {
    title: 'Panel de control',
    overview: 'Resumen',
    stats: 'Estadísticas',
    totalClients: 'Total de clientes',
    totalAccounts: 'Total de cuentas',
    openPositions: 'Posiciones abiertas',
    todayPnL: 'P&L de hoy',
    liveAccounts: 'Cuentas reales',
    demoAccounts: 'Cuentas demo',
    activeClients: 'Clientes activos',
    activeTraders: 'Traders activos',
    newClients: 'Nuevos clientes',
    volumeChart: 'Volumen de trading (7 días)',
    pnlTrend: 'Tendencia P&L (30 días)',
    recentActivity: 'Actividad reciente',
    quickActions: 'Acciones rápidas',
    financialOverview: 'Resumen financiero',
    financialOverview30Days: 'Resumen financiero (30 días)',
    riskAlerts: 'Alertas de riesgo',
    riskDistribution: 'Distribución de riesgo',
    currentPlan: 'Plan actual',
    planUsage: 'Uso del plan',
    allowedMarkets: 'Mercados permitidos',
    accountOverview: 'Resumen de cuentas',
    activeUsers: 'Usuarios activos',
    activeThisMonth: 'Activos este mes',
    plan: 'plan',
    feedLatency: 'Latencia del feed',
    expires: 'Expira',
    cashFlowComparison: 'Comparación de flujo de caja',
    totalTransactions: 'total transacciones',
    totalDeposits: 'total depósitos',
    totalWithdrawals: 'total retiros',
  },
  instruments: {
    title: 'Gestión de instrumentos',
    library: 'Biblioteca de instrumentos',
    enabled: 'Instrumentos habilitados',
    feed: 'Instrumentos del feed',
    symbol: 'Símbolo',
    category: 'Categoría',
    priceScale: 'Escala de precio',
    leverage: 'Apalancamiento',
    spread: 'Spread',
    commission: 'Comisión',
    enable: 'Habilitar',
    disable: 'Deshabilitar',
    bulkEnable: 'Habilitar en masa',
    settings: 'Configuración',
    tradeMode: 'Modo de trading',
    executionType: 'Tipo de ejecución',
    forex: 'Forex',
    crypto: 'Cripto',
    stocks: 'Acciones',
    indices: 'Índices',
    commodities: 'Materias primas',
    general: 'General',
    leverageLots: 'Apalancamiento y lotes',
    spreads: 'Spreads',
    commissions: 'Comisiones',
    riskManagement: 'Gestión de riesgos',
    advanced: 'Avanzado',
    maxLeverage: 'Apalancamiento máximo',
    minLotSize: 'Tamaño mínimo de lote',
    maxLotSize: 'Tamaño máximo de lote',
    lotStep: 'Paso de lote',
    spreadType: 'Tipo de spread',
    spreadMarkup: 'Margen del spread',
    fixedSpread: 'Spread fijo',
    commissionPerLot: 'Comisión por lote',
    commissionType: 'Tipo de comisión',
    stopLevel: 'Nivel de stop',
    freezeLevel: 'Nivel de congelamiento',
    maxPositions: 'Posiciones máximas',
    enableSuccess: 'Instrumento habilitado correctamente',
    disableSuccess: 'Instrumento deshabilitado correctamente',
    updateSuccess: 'Configuración actualizada correctamente',
    bulkEnableSuccess: 'Instrumentos habilitados correctamente',
  },
  clients: {
    title: 'Clientes',
    clientsList: 'Lista de clientes',
    clientDetails: 'Detalles del cliente',
    name: 'Nombre',
    email: 'Correo electrónico',
    phone: 'Teléfono',
    country: 'País',
    kycStatus: 'Estado KYC',
    accountCount: 'Cuentas',
    totalBalance: 'Saldo total',
    lastLogin: 'Último inicio de sesión',
    createdAt: 'Creado el',
    verified: 'Verificado',
    pending: 'Pendiente',
    rejected: 'Rechazado',
    searchPlaceholder: 'Buscar clientes...',
    nameOrEmail: 'Nombre o correo...',
    editClient: 'Editar cliente',
    configureOverride: 'Configurar anulación de usuario',
    noClientsFound: 'No se encontraron clientes',
  },
  accounts: {
    title: 'Cuentas',
    accountsList: 'Lista de cuentas',
    accountDetails: 'Detalles de la cuenta',
    accountNumber: 'Número de cuenta',
    accountType: 'Tipo de cuenta',
    accountGroup: 'Grupo de cuenta',
    accountSettings: 'Configuración de cuenta',
    accountState: 'Estado de cuenta',
    accountActive: 'Cuenta activa',
    balance: 'Saldo',
    equity: 'Capital',
    margin: 'Margen',
    freeMargin: 'Margen libre',
    marginLevel: 'Nivel de margen',
    leverage: 'Apalancamiento',
    credit: 'Crédito',
    debit: 'Débito',
    adjustBalance: 'Ajustar saldo',
    changeLeverage: 'Cambiar apalancamiento',
    live: 'Real',
    demo: 'Demo',
    searchPlaceholder: 'Buscar por número o correo...',
    accountNumberOrEmail: 'Número de cuenta o correo...',
    balanceChange: 'Cambio de saldo',
    reasonForAdjustment: 'Motivo del ajuste...',
    accountUpdatedSuccess: 'Cuenta actualizada correctamente',
    noAccountsFound: 'No se encontraron cuentas',
  },
  trading: {
    title: 'Trading',
    positions: 'Posiciones',
    orders: 'Órdenes',
    history: 'Historial',
    symbol: 'Símbolo',
    side: 'Lado',
    volume: 'Volumen',
    openPrice: 'Precio de apertura',
    currentPrice: 'Precio actual',
    pnl: 'P&L',
    buy: 'Compra',
    sell: 'Venta',
    open: 'Abierto',
    pending: 'Pendiente',
    closed: 'Cerrado',
    closedAt: 'Cerrado el',
    openedAt: 'Abierto el',
    price: 'Precio',
    totalTrades: 'Total de operaciones',
    winningTrades: 'Operaciones ganadoras',
    losingTrades: 'Operaciones perdedoras',
    totalPnL: 'P&L total',
    account: 'Cuenta',
    status: 'Estado',
    swap: 'Swap',
    commission: 'Comisión',
    ticket: 'Ticket',
    noPositions: 'No hay posiciones abiertas',
    noOrders: 'No hay órdenes pendientes',
    noHistory: 'No hay historial de trading',
    bid: 'Bid',
    ask: 'Ask',
    tradingManagement: 'Gestión de trading',
    liveMonitoring: 'Monitoreo en vivo',
    disconnected: 'Desconectado',
    activeTraders: 'Traders activos',
    openPositions: 'Posiciones abiertas',
    pendingOrders: 'Órdenes pendientes',
    floatPnL: 'P&L flotante',
    accountState: 'Estado de cuenta',
    marginCall: 'LLAMADA DE MARGEN',
    stopOutRisk: 'RIESGO DE STOP-OUT',
    live: 'EN VIVO',
    offline: 'SIN CONEXIÓN',
    snapshot: 'INSTANTÁNEA',
    marginLvl: 'Nivel de margen',
    openTrades: 'Operaciones abiertas',
    freeMargin: 'Margen libre',
    marginUsed: 'Margen usado',
    balance: 'Saldo',
    equity: 'Capital',
    credit: 'Crédito',
    slTp: 'SL / TP',
    fees: 'Comisiones',
    netPnL: 'P&L neto',
    grossPnL: 'P&L bruto',
    reason: 'Motivo',
    openedClosed: 'Abierto / Cerrado',
    closePrice: 'Precio de cierre',
    reserved: 'Reservado',
    reservedMargin: 'Margen reservado',
    created: 'Creado',
    triggerPrice: 'Precio de activación',
    duration: 'Duración',
    closedTrades: 'Operaciones cerradas',
    activeTrades: 'Activo',
    stopLoss: 'Stop Loss',
    takeProfit: 'Take Profit',
    closePosition: 'Cerrar posición',
    cancelOrder: 'Cancelar orden',
    modifyPosition: 'Modificar posición',
    thisActionCannotBeUndone: 'Esta acción no se puede deshacer',
    enterStopLoss: 'Ingrese el precio de stop loss',
    enterTakeProfit: 'Ingrese el precio de take profit',
    filterTrading: 'Filtrar trading',
    traderSymbolAccount: 'Trader, símbolo, cuenta...',
    noFound: 'No se encontraron {tab}',
    showingOf: 'Mostrando {from}–{to} de {total} traders',
    traderCount: '{count} trader(s) · {total} {tab}',
    positionClosedSuccess: 'Posición cerrada correctamente',
    orderCancelledSuccess: 'Orden cancelada correctamente',
    positionModifiedSuccess: 'Posición modificada correctamente',
    failedToClosePosition: 'Error al cerrar la posición',
    failedToCancelOrder: 'Error al cancelar la orden',
    failedToModifyPosition: 'Error al modificar la posición',
    invalidPosition: 'Posición inválida: ID faltante',
  },
  reports: {
    title: 'Reportes',
    exposure: 'Reporte de exposición',
    profitability: 'Rentabilidad de clientes',
    daily: 'Reporte diario',
    dateRange: 'Rango de fechas',
    totalExposure: 'Exposición total',
    netVolume: 'Volumen neto',
    topWinners: 'Principales ganadores',
    topLosers: 'Principales perdedores',
    buyVolume: 'Volumen de compra',
    sellVolume: 'Volumen de venta',
    positionCount: 'Cantidad de posiciones',
    winRate: 'Tasa de éxito',
    rank: 'Rango',
    client: 'Cliente',
    noData: 'No hay datos disponibles',
    totalVolume: 'Volumen total',
    commission: 'Comisión',
    activeAccounts: 'Cuentas activas',
    export: 'Exportar',
    download: 'Descargar',
    positions: 'Posiciones',
    trades: 'Operaciones',
    winning: 'Ganadoras',
    losing: 'Perdedoras',
  },
  settings: {
    title: 'Configuración',
    brokerInfo: 'Información del bróker',
    brokerSettings: 'Configuración del bróker',
    brokerName: 'Nombre del bróker',
    brokerNameRequired: 'Nombre del bróker *',
    brokerLogo: 'Logo del bróker',
    brokerStatus: 'Estado del bróker',
    domain: 'Dominio',
    primaryColor: 'Color principal',
    secondaryColor: 'Color secundario',
    logo: 'Logo',
    supportEmail: 'Correo de soporte',
    supportPhone: 'Teléfono de soporte',
    generalInfo: 'Información general',
    branding: 'Identidad de marca',
    accountGroups: 'Grupos de cuentas',
    addNewGroup: 'Agregar nuevo grupo',
    createFirstGroup: 'Crear tu primer grupo',
    noGroupsFound: 'No se encontraron grupos de cuentas',
    default: 'Predeterminado',
    maxLeverage: 'Apalancamiento máximo',
    marginCall: 'Llamada de margen',
    stopOut: 'Stop out',
    commission: 'Comisión',
    maxLotSize: 'Tamaño máximo de lote',
    execution: 'Ejecución',
    hedgingAllowed: 'Cobertura permitida',
    scalpingAllowed: 'Scalping permitido',
    eaTrading: 'Trading con EA',
    nbpEnabled: 'NBP habilitado',
    saving: 'Guardando...',
    groupName: 'Nombre del grupo',
    description: 'Descripción',
    editGroup: 'Editar grupo',
    deleteGroup: 'Eliminar grupo',
    cannotDeleteDefault: 'No se puede eliminar el grupo predeterminado',
    confirmDelete: '¿Confirmar la eliminación de "{name}"? Esta acción no se puede deshacer.',
    groupCreatedSuccess: 'Grupo creado correctamente',
    groupUpdatedSuccess: 'Grupo actualizado correctamente',
    groupDeletedSuccess: 'Grupo eliminado correctamente',
    failedToSave: 'Error al guardar el grupo',
    failedToDelete: 'Error al eliminar el grupo',
    failedToLoad: 'Error al cargar los grupos de cuentas',
    configureYourBroker: 'Configura la información de tu bróker',
    loadingSettings: 'Cargando configuración...',
    legalName: 'Razón social',
    licenseNumber: 'Número de licencia',
    environment: 'Entorno',
    contactInformation: 'Información de contacto',
    readOnly: 'Solo lectura',
    readOnlyContactSupport: 'Solo lectura — contacta soporte para cambiar',
    supportedLanguages: 'Idiomas compatibles',
    selectLanguagesDescription: 'Selecciona los idiomas disponibles en el portal del cliente.',
    systemLimits: 'Límites del sistema',
    maxAccounts: 'Cuentas máximas',
    maxConcurrentTrades: 'Operaciones simultáneas máximas',
    maintenanceMode: 'Modo mantenimiento',
    enableMaintenanceMode: 'Habilitar modo mantenimiento',
    maintenanceModeDescription: 'Cuando está habilitado, los clientes ven el mensaje de mantenimiento',
    maintenanceMessage: 'Mensaje de mantenimiento',
    maintenanceMessagePlaceholder: 'Estamos realizando mantenimiento programado. Vuelve pronto.',
    saveChanges: 'Guardar cambios',
    howToConnectDomain: 'Cómo conectar tu dominio',
    unlockToEdit: 'Desbloquear para editar el dominio',
    lockDomain: 'Bloquear dominio',
    changingDomainWarning: 'Cambiar tu dominio puede interrumpir el acceso de los clientes. ¿Confirmar?',
    changingDomainWarningLong: 'Cambiar tu dominio puede interrumpir el acceso y los DNS temporalmente. ¿Confirmar?',
    domainBreakWarning: '⚠️ Cambiar el dominio puede interrumpir el acceso temporalmente',
    domainBreakWarningLong: '⚠️ Cambiar el dominio puede interrumpir el acceso y el enrutamiento DNS temporalmente',
  },
  accountGroups: {
    title: 'Grupos de cuentas',
    activeGroups: 'activo',
    defaultGroups: 'predeterminado',
    addNewGroup: 'Agregar nuevo grupo',
    createFirstGroup: 'Crear tu primer grupo',
    noGroupsFound: 'No se encontraron grupos de cuentas',
    groupDetails: 'Detalles del grupo',
    pricingOverrides: 'Anulaciones de precios',
    riskSettings: 'Configuración de riesgo',
    tradingSettings: 'Configuración de trading',
  },
  groupPricing: {
    title: 'Anulaciones de precios de grupo',
    infoBanner: 'Anulaciones de precios del grupo de cuentas',
    infoDescription: 'Configura precios personalizados para grupos. Deja vacío (NULL) para usar los valores predeterminados.',
    editPricingOverrides: 'Editar anulaciones de precios',
    spreadMarkup: 'Margen del spread',
    spreadMarkupPips: 'Margen del spread (pips)',
    commission: 'Comisión',
    commissionPerLot: 'Comisión por lote (USD)',
    maxLeverageOverride: 'Anulación de apalancamiento máximo',
    brokerDefault: 'Predeterminado del bróker',
    useBrokerDefault: 'Usar predeterminado del bróker',
    clearUseBrokerDefault: 'Limpiar (usar predeterminado del bróker)',
    saveOverrides: 'Guardar anulaciones',
    overridesUpdatedSuccess: 'Anulaciones de precios actualizadas correctamente',
    failedToUpdate: 'Error al actualizar las anulaciones',
    leaveEmptyInfo: 'Deja vacío para usar los valores del bróker.',
    pips: 'pips',
    perLot: '/lote',
  },
  kyc: {
    title: 'Panel de KYC',
    allKyc: 'Todo KYC',
    allStatus: 'Todos los estados',
    allKycStatus: 'Todos los estados KYC',
    pending: 'Pendiente',
    approved: 'Aprobado',
    rejected: 'Rechazado',
    verified: 'Verificado',
    actionNeeded: 'Acción requerida',
    awaitingAction: 'Esperando acción',
    allCaughtUp: '¡Todo al día!',
    noApplications: 'No hay solicitudes KYC pendientes.',
    searchPlaceholder: 'Buscar por nombre, correo o ID...',
    nameEmailOrId: 'ID, nombre o correo...',
    confirmApproval: 'Confirmar aprobación KYC',
    confirmRejection: 'Confirmar rechazo — ingresa un motivo (requerido).',
    rejectionReason: 'Explica por qué se rechaza esta solicitud (requerido)',
    approveSuccess: 'KYC aprobado correctamente',
    rejectSuccess: 'KYC rechazado correctamente',
    failedToApprove: 'Error al aprobar KYC',
    failedToReject: 'Error al rechazar KYC',
    basicVerified: 'Verificación básica',
    fullVerified: 'Verificación completa',
    allApplications: 'Todas las solicitudes',
    kycVerification: 'Verificación KYC',
    reviewManageDesc: 'Revisa y gestiona las solicitudes de verificación',
    pluginSettings: 'Configuración del plugin',
    reviewKycApplication: 'Revisar solicitud KYC',
    verificationLevel: 'Nivel de verificación',
    personalInformation: 'Información personal',
    fullName: 'Nombre completo',
    dateOfBirth: 'Fecha de nacimiento',
    nationality: 'Nacionalidad',
    addressLabel: 'Dirección',
    sourceOfFunds: 'Origen de fondos',
    noPersonalData: 'No se han enviado datos personales',
    uploadedDocuments: 'Documentos subidos',
    noDocumentsUploaded: 'No se han subido documentos',
    yourDecision: 'Tu decisión',
    approve: 'Aprobar',
    reject: 'Rechazar',
    rejectionReasonLabel: 'Motivo del rechazo',
    submitting: 'Enviando...',
    submitReview: 'Enviar revisión',
    previewNotAvailable: 'Vista previa no disponible',
    downloadFile: 'Descargar archivo',
    uploaded: 'Subido',
    pendingReview: 'Pendiente de revisión',
    allLevels: 'Todos los niveles',
    allStatuses: 'Todos los estados',
    allActions: 'Todas las acciones',
    userCol: 'Usuario',
    currentLevel: 'Nivel actual',
    docsCol: 'Docs',
    lastUpdated: 'Última actualización',
    levelCol: 'Nivel',
    actionCol: 'Acción',
    performedBy: 'Realizado por',
    detailsCol: 'Detalles',
    dateTime: 'Fecha y hora',
    submittedCol: 'Enviado',
    noApplicationsFound: 'No se encontraron solicitudes',
    noAuditRecords: 'No se encontraron registros de auditoría',
    noMatchingApplications: 'No hay solicitudes coincidentes',
    noPendingApplications: 'No hay solicitudes pendientes',
    systemAuto: 'Sistema (Auto)',
    admin: 'Admin',
    traderLabel: 'Trader',
    upgradedTo: 'Actualizado a',
    pendingApplications: 'solicitud pendiente',
    pendingApplicationsPlural: 'solicitudes pendientes',
    users: 'usuario',
    usersPlural: 'usuarios',
    records: 'registro',
    recordsPlural: 'registros',
    applications: 'solicitud',
    applicationsPlural: 'solicitudes',
    totalUsers: 'Total de usuarios',
    basicVerifiedStat: 'Verificación básica',
    moderateVerified: 'Verificación moderada',
    fullyVerified: 'Totalmente verificado',
    pendingSuffix: '+{count} pendiente',
    levelBasic: 'Básico',
    levelModerate: 'Moderado',
    levelVerified: 'Verificado',
    notStarted: 'No iniciado',
    none: 'Ninguno',
    unknown: 'Desconocido',
    review: 'Revisar',
    auditLog: 'Registro de auditoría',
    requiredDocuments: 'Documentos requeridos',
    requiredDocsDesc: 'Selecciona los documentos requeridos para cada nivel KYC.',
    kycDocuments: 'Documentos KYC {level}',
    selected: '{count} seleccionado',
    approvalMode: 'Modo de aprobación',
    manualReview: 'Revisión manual',
    autoApprove: 'Aprobación automática',
    autoApproveLevels: 'Niveles de aprobación automática',
    basicKyc: 'KYC básico',
    moderateKyc: 'KYC moderado',
    verifiedKyc: 'KYC verificado',
    enforceOnDeposit: 'Requerir KYC en depósitos',
    enforceOnWithdrawal: 'Requerir KYC en retiros',
    basic: 'Básico',
    moderate: 'Moderado',
    verified: 'Verificado',
    howItWorks: 'Cómo funciona:',
    howItWorksBullet1: 'Montos por debajo del umbral básico: No se requiere KYC',
    howItWorksBullet2: 'Montos sobre el básico: Se requiere KYC básico',
    howItWorksBullet3: 'Montos sobre el moderado: Se requiere KYC moderado',
    howItWorksBullet4: 'Montos sobre el verificado: Se requiere verificación completa',
    saveConfiguration: 'Guardar configuración',
    savingConfiguration: 'Guardando...',
    openKycDashboard: 'Abrir panel KYC',
    enableToViewStats: 'Habilita el plugin para ver estadísticas',
    statNone: 'Ninguno',
    docGovIdFrontLabel: 'ID gubernamental (frente)',
    docGovIdFrontDesc: 'Pasaporte, licencia de conducir o DNI - frente',
    docGovIdBackLabel: 'ID gubernamental (dorso)',
    docGovIdBackDesc: 'Dorso de la tarjeta de identificación',
    docSelfieLabel: 'Selfie con ID',
    docSelfieDesc: 'Foto sosteniendo el ID junto al rostro',
    docProofAddressLabel: 'Comprobante de domicilio',
    docProofAddressDesc: 'Factura de servicios o extracto bancario (< 3 meses)',
    docBankStatementLabel: 'Extracto bancario',
    docBankStatementDesc: 'Extracto reciente con nombre y cuenta',
    docSourceFundsLabel: 'Origen de fondos',
    docSourceFundsDesc: 'Documento que prueba el origen de los fondos',
    docEmploymentLabel: 'Carta de empleo',
    docEmploymentDesc: 'Carta de confirmación del empleador',
    docTaxIdLabel: 'Documento de identificación fiscal',
    docTaxIdDesc: 'Certificado de identificación fiscal',
    docOtherLabel: 'Otros documentos',
    docOtherDesc: 'Documentos de soporte adicionales',
    auditActions: {
      submitted: 'Enviado',
      approved: 'Aprobado',
      rejected: 'Rechazado',
      document_uploaded: 'Doc subido',
      document_approved: 'Doc aprobado',
      document_rejected: 'Doc rechazado',
      level_upgraded: 'Nivel actualizado',
      resubmission: 'Reenvío',
    },
  },
  deposits: {
    title: 'Depósitos',
    allDeposits: 'Todos los depósitos',
    allStatuses: 'Todos los estados',
    pending: 'Pendiente',
    approved: 'Aprobado',
    rejected: 'Rechazado',
    completed: 'Completado',
    searchPlaceholder: 'Buscar depósitos...',
    searchByIdNameEmail: 'Buscar por ID, nombre o correo...',
    idNameOrEmail: 'ID, nombre o correo...',
    depositProof: 'Comprobante de depósito',
    depositProofPdf: 'PDF comprobante de depósito',
    amount: 'Monto',
    method: 'Método',
    status: 'Estado',
    trader: 'Trader',
    date: 'Fecha',
    actions: 'Acciones',
    approve: 'Aprobar',
    reject: 'Rechazar',
    confirmApproval: 'Confirmar aprobación — esto acreditará el saldo del trader.',
    confirmRejection: 'Confirmar rechazo — ingresa un motivo (opcional).',
    rejectionReason: 'Motivo del rechazo (opcional)...',
    approveSuccess: 'Depósito aprobado correctamente',
    rejectSuccess: 'Depósito rechazado correctamente',
    failedToApprove: 'Error al aprobar el depósito',
    failedToReject: 'Error al rechazar el depósito',
    noDepositsFound: 'No se encontraron depósitos',
    proofThumbnail: 'Miniatura del comprobante',
    zoomIn: 'Acercar',
    zoomOut: 'Alejar',
    openInNewTab: 'Abrir en nueva pestaña',
    bank: 'Banco',
    crypto: 'Cripto',
    card: 'Tarjeta',
    bankPerCountry: 'Banco (por país)',
    bankPerUser: 'Banco (por usuario)',
    bankTransfer: 'Transferencia bancaria',
    bankTransferPerCountry: 'Transferencia (por país)',
    bankTransferPerUser: 'Transferencia (por usuario)',
    averageDeposit: 'Depósito promedio',
  },
  withdrawals: {
    title: 'Retiros',
    allWithdrawals: 'Todos los retiros',
    allStatuses: 'Todos los estados',
    pending: 'Pendiente',
    approved: 'Aprobado',
    rejected: 'Rechazado',
    completed: 'Completado',
    searchPlaceholder: 'Buscar retiros...',
    searchByIdNameEmail: 'Buscar por ID, nombre o correo...',
    idNameOrEmail: 'ID, nombre o correo...',
    amount: 'Monto',
    method: 'Método',
    status: 'Estado',
    trader: 'Trader',
    date: 'Fecha',
    actions: 'Acciones',
    approve: 'Aprobar',
    reject: 'Rechazar',
    confirmApproval: 'Confirmar aprobación — los fondos serán enviados al trader.',
    confirmWithdrawalApproval: 'Confirmar aprobación del retiro — los fondos serán liberados.',
    confirmRejection: 'Confirmar rechazo — ingresa un motivo (opcional).',
    rejectionReason: 'Motivo del rechazo (opcional)...',
    approveSuccess: 'Retiro aprobado correctamente',
    rejectSuccess: 'Retiro rechazado correctamente',
    failedToApprove: 'Error al aprobar el retiro',
    failedToReject: 'Error al rechazar el retiro',
    noWithdrawalsFound: 'No se encontraron retiros',
    averageWithdrawal: 'Retiro promedio',
  },
  auditLog: {
    title: 'Registro de auditoría',
    allActions: 'Todas las acciones',
    allEvents: 'Todos los eventos',
    allLevels: 'Todos los niveles',
    searchPlaceholder: 'Buscar en el registro...',
    emailActionOrId: 'Correo, acción o ID...',
    event: 'Evento',
    user: 'Usuario',
    action: 'Acción',
    timestamp: 'Marca de tiempo',
    details: 'Detalles',
    level: 'Nivel',
    info: 'Información',
    warning: 'Advertencia',
    error: 'Error',
    critical: 'Crítico',
    noLogsFound: 'No se encontraron registros',
    administrativeAction: 'Se registró una acción administrativa.',
    filterAuditLog: 'Filtrar registro de auditoría',
    reset: 'Restablecer',
    eventType: 'Tipo de evento',
    apply: 'Aplicar',
    totalEvents: 'Total de eventos',
    depositEvents: 'Eventos de depósito',
    withdrawalEvents: 'Eventos de retiro',
    noEventsMatch: 'Ningún evento coincide',
    noEntriesMatch: 'Ninguna entrada coincide con el filtro.',
    showAll: 'Mostrar todo',
    events: 'evento',
    eventsPlural: 'eventos',
    totalEventsRecorded: 'Total de eventos registrados',
    performedBy: 'Realizado por',
    amount: 'Monto',
    paymentMethod: 'Método de pago',
    balanceChange: 'Cambio de saldo',
    statusChange: 'Cambio de estado',
    rejectionReason: 'Motivo del rechazo',
    actionWithdrawalRequested: 'Retiro solicitado',
    actionDepositSubmitted: 'Depósito enviado',
    actionProofUploaded: 'Comprobante subido',
    actionDepositApproved: 'Depósito aprobado',
    actionDepositRejected: 'Depósito rechazado',
    actionWithdrawalApproved: 'Retiro aprobado',
    actionWithdrawalRejected: 'Retiro rechazado',
    actionFundsLocked: 'Fondos bloqueados',
    actionFundsReturned: 'Fondos devueltos',
    fundsLockedSummary: 'Fondos bloqueados pendientes de revisión del retiro.',
    fundsReturnedSummary: 'Fondos bloqueados devueltos tras el rechazo.',
    depositsTab: 'Depósitos',
    withdrawalsTab: 'Retiros',
  },
  plugins: {
    title: 'Plugins',
    backToPlugins: 'Volver a plugins',
    searchPlaceholder: 'Buscar plugins...',
    countrySelectNoMatch: 'Sin coincidencias',
    configurePlugin: 'Configurar plugin',
    pressEscToClose: 'Presiona {key} para cerrar',
    loadingUsers: 'Cargando...',
    available: 'Disponible',
    active: 'Activo',
    activate: 'Activar',
    deactivate: 'Desactivar',
    configure: 'Configurar',
    documentation: 'Documentación',
    settings: 'Configuración',
    noPluginsFound: 'No se encontraron plugins',
    pluginDetails: 'Detalles del plugin',
    version: 'Versión',
    author: 'Autor',
    description: 'Descripción',
    filterInactive: 'Inactivo',
    paymentGateways: 'Pasarelas de pago',
    stripeTitle: 'Stripe',
    stripeDescription: 'Aceptar pagos vía Stripe',
    paypalTitle: 'PayPal',
    paypalDescription: 'Aceptar pagos vía PayPal',
    communicationTools: 'Herramientas de comunicación',
    twilioTitle: 'Twilio SMS',
    twilioDescription: 'Enviar notificaciones SMS',
    mailgunTitle: 'Mailgun',
    mailgunDescription: 'Servicio de entrega de correo',
    bankFieldAccountHolder: 'Titular de la cuenta',
    bankFieldBankName: 'Nombre del banco',
    bankFieldAccountNumber: 'Número de cuenta',
    bankFieldRoutingNumber: 'Número de ruta (opcional)',
    bankFieldSetAsDefault: 'Establecer como predeterminado',
    copyTradingTitle: 'Copy Trading',
    copyTradingDescription: 'Habilitar funciones de copy trading',
    tradingTools: 'Herramientas de trading',
    mam: 'MAM/PAMM',
    apiKey: 'Clave API',
    apiSecret: 'Secreto API',
    accountSid: 'SID de cuenta',
    authToken: 'Token de autenticación',
    authDomain: 'Dominio de autenticación',
    appId: 'ID de aplicación',
    loadingPlugins: 'Cargando plugins...',
    noPluginsMatch: 'Ningún plugin coincide',
    tryDifferentSearch: 'Intenta una búsqueda diferente',
    tryAdjustingSearch: 'Intenta ajustar tu búsqueda',
    activeCount: '{count} activo · {owned} propio · {available} en tienda',
    ofPurchasedActive: 'de {count} comprados activos',
    expired: 'Expirado',
    expires: 'Expira',
    free: 'Gratis',
    buyPlugin: 'Comprar — ${price}{cycle}',
    openInFullPage: 'Abrir en página completa',
    noConfigPanel: 'No hay panel de configuración disponible.',
    currentStatus: 'Estado actual',
    failedToUpdateKyc: 'Error al actualizar la configuración KYC',
    filterAll: 'Todos',
    filterActive: 'Activo',
    filterOwned: 'Propio',
    filterStore: 'Tienda',
    pluginNotFound: 'Plugin no encontrado',
    loadingPlugin: 'Cargando plugin...',
    failedToLoadPlugin: 'Error al cargar el plugin',
    noConfigAvailable: 'No hay panel de configuración disponible.',
    activeStatus: 'Activo',
    editLabel: 'Editar',
    newLabel: 'Nuevo',
    addLabel: 'Agregar',
    saveLabel: 'Guardar',
    cancelLabel: 'Cancelar',
    globalBankAccount: 'Cuenta bancaria global',
    addBankAccount: 'Agregar cuenta bancaria',
    defaultLabel: '(predeterminado)',
    cryptoWallet: 'Monedero cripto',
    addCryptoWallet: 'Agregar monedero cripto',
    coinPlaceholder: 'Moneda (ej. BTC)',
    networkPlaceholder: 'Red (ej. mainnet)',
    walletAddressPlaceholder: 'Dirección del monedero',
    labelOptionalPlaceholder: 'Etiqueta (opcional)',
    paymentLink: 'Enlace de pago',
    addPaymentLink: 'Agregar enlace de pago',
    linkNamePlaceholder: 'Nombre (ej. Stripe Checkout)',
    perUserBankAccount: 'Cuenta bancaria por usuario',
    addUserBankMapping: 'Agregar mapeo usuario → banco',
    editExistingAccount: 'Editar cuenta existente',
    assignedUsers: 'Usuarios asignados',
    pickTraders: 'Seleccionar traders',
    searchAddTrader: 'Buscar y agregar trader...',
    perCountryBankAccount: 'Cuenta bancaria por país',
    addCountryBankMapping: 'Agregar mapeo país → banco',
    mappedCountries: 'Países mapeados',
    pickCountries: 'Seleccionar países',
    searchAddCountries: 'Buscar y agregar países...',
    badgeActive: 'Activo',
    badgeInactive: 'Inactivo',
    badgeExpired: 'Expirado',
    purchasePlugin: 'Comprar plugin',
    paymentMethod: 'Método de pago',
    generatePaymentAddress: 'Generar dirección de pago',
    sendExactly: 'Enviar exactamente',
    toAddressBelow: 'a la dirección de abajo',
    paymentAddress: 'Dirección de pago',
    waitingForPayment: 'Esperando pago...',
    paymentDetected: '¡Pago detectado! Confirmando...',
    confirmationsReceived: '{count} confirmación recibida',
    confirmationsReceivedPlural: '{count} confirmaciones recibidas',
    expiresIn: 'Expira en:',
    paymentId: 'ID de pago:',
    paymentConfirmed: '¡Pago confirmado!',
    pluginActivated: '{name} ha sido activado.',
    networkError: 'Error de red. Por favor intenta de nuevo.',
    failedToCreatePayment: 'Error al crear el pago',
    paymentExpired: 'Ventana de pago expirada. Crea un nuevo pago.',
  },
  apiDocs: {
    title: 'Documentación API',
    authentication: 'Autenticación',
    baseUrl: 'URL base:',
    allRequestsRequire: 'Todas las solicitudes requieren dos encabezados:',
    apiKeyManagement: 'Gestión de claves API con controles de alcance',
    billing: 'Facturación',
    apiAccess: 'Acceso API',
    apiAccessAddon: 'Complemento de acceso API activo',
    buyAddon: 'Comprar complemento — $199/mes',
    getAccounts: 'GET /accounts',
    getAccountDetails: 'GET /accounts/:id',
    updateAccount: 'PATCH /accounts/:id',
    getDeposits: 'GET /deposits',
    approveDeposit: 'POST /deposits/:id/approve',
    rejectDeposit: 'POST /deposits/:id/reject',
    getWithdrawals: 'GET /withdrawals',
    approveWithdrawal: 'POST /withdrawals/:id/approve',
    rejectWithdrawal: 'POST /withdrawals/:id/reject',
    approvalsDescription: 'Aprobar depósitos y retiros programáticamente',
    approveDepositDesc: 'Aprobar depósito (estado debe ser proof_uploaded).',
    approveWithdrawalDesc: 'Aprobar un retiro pendiente.',
    restApi: 'REST API',
    baseUrlLabel: 'URL base:',
    yourApiKeys: 'Tus claves API',
    noApiKeysYet: 'Sin claves API',
    generateNewKey: 'Generar nueva clave',
    revokeKey: 'Revocar',
    rateLimit: 'Límite de tasa',
    maxKeys: 'Claves máximas',
    reqPerMin: '{limit} req/min',
    exampleRequest: 'Solicitud de ejemplo',
    queryParameters: 'Parámetros de consulta',
    endpoints: 'endpoint',
    endpointsPlural: 'endpoints',
    includedInPlan: 'Incluido en tu plan Enterprise',
    addonActive: 'Complemento de acceso API activo',
    restApiAccess: 'Acceso REST API',
    restApiDesc: 'El acceso REST API está disponible en el plan Enterprise o como complemento.',
    featureReadClients: 'Leer clientes, cuentas e historial de trading',
    featureApprovePayments: 'Aprobar depósitos y retiros programáticamente',
    featureApiKeyManagement: 'Gestión de claves API con controles de alcance',
    featureRateLimit: 'Hasta 60 solicitudes por minuto por clave',
    featureInteractiveDocs: 'Documentación interactiva en tu panel',
    upgradeToEnterprise: 'Actualizar a Enterprise',
    buyAddonPrice: 'Comprar complemento — $199/mes',
    generateApiKey: 'Generar clave API',
    keyName: 'Nombre de la clave',
    keyNamePlaceholder: 'ej. Clave de producción',
    scopes: 'Alcances',
    generating: 'Generando...',
    generateKey: 'Generar clave',
    keyGenerated: 'Clave generada',
    copySecretWarning: '⚠️ Copia tu secreto ahora — no se mostrará de nuevo.',
    apiKeyLabel: 'Clave API',
    apiSecretLabel: 'Secreto API',
    done: 'Listo',
    enterKeyName: 'Ingresa un nombre de clave',
    failedToCreateKey: 'Error al crear la clave',
    keyRevoked: 'Clave revocada',
    confirmRevoke: '¿Revocar esta clave API? Esta acción no se puede deshacer.',
  },
  notifications: {
    title: 'Configuración de notificaciones',
    emailNotifications: 'Notificaciones por correo',
    smsNotifications: 'Notificaciones SMS',
    pushNotifications: 'Notificaciones push',
    deposits: 'Depósitos',
    withdrawals: 'Retiros',
    newClients: 'Nuevos clientes',
    kycApplications: 'Solicitudes KYC',
    systemAlerts: 'Alertas del sistema',
    enabled: 'Habilitado',
    disabled: 'Deshabilitado',
    saveSettings: 'Guardar configuración',
    settingsSaved: 'Configuración guardada',
    notificationChannels: 'Canales de notificación',
    configureChannels: 'Configura cómo la plataforma envía alertas a los clientes.',
    saveAll: 'Guardar todo',
    saving: 'Guardando...',
    enableToConfigure: 'Habilita para configurar {title}',
    emailSmtp: 'Correo electrónico (SMTP)',
    emailSmtpSubtitle: 'Enviar correos mediante tu propio servidor SMTP',
    recommended: 'Recomendado',
    smtpHost: 'Host SMTP',
    smtpPort: 'Puerto SMTP',
    usernameEmail: 'Usuario / Correo',
    passwordAppPassword: 'Contraseña / Contraseña de app',
    fromEmail: 'Correo remitente',
    fromName: 'Nombre remitente',
    useTls: 'Usar TLS / STARTTLS',
    useTlsHint: 'Recomendado para puerto 587.',
    sendTestEmail: 'Enviar correo de prueba',
    pushFcm: 'Notificaciones push (FCM)',
    pushFcmSubtitle: 'Firebase Cloud Messaging para Android, iOS y Web',
    pushSetupRequired: 'Configuración requerida',
    pushSetupDesc: 'Ve a Firebase Console → Configuración del proyecto → Cuentas de servicio.',
    serviceAccountCredentials: 'Credenciales de cuenta de servicio',
    clientTokenStatus: 'Estado del token del cliente',
    clientTokenDesc: 'Los tokens push se registran automáticamente al iniciar sesión.',
    testPush: 'Probar Push',
    webAppConfig: 'Configuración de la app web',
    webAppConfigured: 'Configurado — {project}',
    webAppRequired: 'Requerido para notificaciones en navegador y móvil',
    webAppWhereToFind: 'Dónde encontrar estos datos',
    webAppWhereToFindDesc: 'Firebase Console → Configuración del proyecto → Tus apps',
    saveWebConfig: 'Guardar configuración web',
    vapidKey: 'Clave VAPID',
    vapidKeyHint: '— Pestaña Cloud Messaging → Certificados Web Push',
    credentialsOnFile: 'Credenciales en archivo',
    credentialsStoredSecurely: 'Almacenadas de forma segura en el servidor',
    replaceCredentials: 'Reemplazar',
    uploadServiceAccount: 'Subir JSON de cuenta de servicio',
    uploadServiceAccountHint: 'Haz clic para seleccionar — se valida y almacena de forma segura',
    uploadingValidating: 'Subiendo y validando...',
    uploadSuccess: 'Credenciales de Firebase subidas correctamente',
    uploadFailed: 'Error — verifica que el archivo sea un JSON de Firebase válido',
    saveWebConfigSuccess: 'Configuración web de Firebase guardada',
    saveWebConfigFailed: 'Error al guardar la configuración web',
    smsTwilio: 'SMS (Twilio)',
    smsTwilioSubtitle: 'Enviar SMS vía Twilio a clientes',
    smsSetupRequired: 'Configuración requerida',
    smsSetupDesc: 'Obtén tus credenciales en console.twilio.com',
    accountSid: 'SID de cuenta',
    accountSidHint: 'Comienza con AC...',
    authToken: 'Token de autenticación',
    fromPhoneNumber: 'Número remitente',
    fromPhoneHint: 'Formato E.164, ej. +5491123456789',
    sendTestSms: 'Enviar SMS de prueba',
    statusConnected: 'Conectado',
    statusError: 'Error',
    statusUntested: 'No probado',
    statusTesting: 'Probando...',
    notificationRouting: 'Enrutamiento de notificaciones',
    notificationRoutingDesc: 'Elige los canales para cada tipo de notificación',
    noChannelsEnabled: 'Sin canales habilitados',
    noChannelsEnabledDesc: 'Habilita al menos un canal para configurar el enrutamiento',
    notifMarginCall: 'Llamada de margen',
    notifMarginCallDesc: 'Cuando el nivel de margen baja del umbral',
    notifLiquidation: 'Liquidación',
    notifLiquidationDesc: 'Cuando se cierran posiciones forzosamente',
    notifDeposit: 'Depósito',
    notifDepositDesc: 'Cuando se confirma un depósito',
    notifWithdrawal: 'Retiro',
    notifWithdrawalDesc: 'Cuando se procesa un retiro',
    notifTradeOpened: 'Operación abierta',
    notifTradeOpenedDesc: 'Cuando se abre una nueva posición',
    notifTradeClosed: 'Operación cerrada',
    notifTradeClosedDesc: 'Cuando se cierra una posición',
    failedToLoad: 'Error al cargar la configuración',
    failedToSave: 'Error al guardar',
    testSuccess: 'Prueba de {channel} exitosa — revisa tu bandeja de entrada',
    testFailed: 'Prueba de {channel} fallida',
  },
  upgrade: {
    title: 'Actualizar plan',
    currentPlan: 'Plan actual',
    choosePlan: 'Elegir plan',
    basic: 'Básico',
    professional: 'Profesional',
    enterprise: 'Empresarial',
    perMonth: '/mes',
    perYear: '/año',
    monthly: 'Mensual',
    annually: 'Anual',
    features: 'Características',
    selectPlan: 'Seleccionar plan',
    currentPlanLabel: 'Plan actual',
    upgradeTo: 'Actualizar a',
    contactSales: 'Contactar ventas',
    unlimitedClients: 'Clientes ilimitados',
    unlimitedAccounts: 'Cuentas ilimitadas',
    advancedReporting: 'Reportes avanzados',
    prioritySupport: 'Soporte prioritario',
    apiAccess: 'Acceso API',
    customBranding: 'Marca personalizada',
    whiteLabel: 'Marca blanca',
    dedicatedManager: 'Gerente de cuenta dedicado',
    upgradeAvailable: 'Actualización disponible',
    plan: 'Plan',
    unlock: 'Desbloquear',
    apiAccessFeature: ', acceso API',
    andMore: 'y más',
    renew: 'Renovar',
  },
  theme: {
    light: 'Modo claro',
    dark: 'Modo oscuro',
    toggle: 'Cambiar tema',
  },
  language: {
    english: 'English',
    arabic: 'العربية',
    turkish: 'Türkçe',
    select: 'Seleccionar idioma',
  },
  errors: {
    general: 'Algo salió mal',
    networkError: 'Error de red. Verifica tu conexión.',
    unauthorized: 'No autorizado. Por favor inicia sesión de nuevo.',
    forbidden: 'Acceso denegado.',
    notFound: 'Recurso no encontrado.',
    serverError: 'Error del servidor. Por favor intenta más tarde.',
    actionFailed: 'Acción fallida',
  },
  success: {
    saved: 'Guardado correctamente',
    updated: 'Actualizado correctamente',
    deleted: 'Eliminado correctamente',
    created: 'Creado correctamente',
    copied: 'Copiado al portapapeles',
  },
  time: {
    seconds: 'segundos',
    minutes: 'minutos',
    hours: 'horas',
    days: 'días',
    weeks: 'semanas',
    months: 'meses',
    years: 'años',
    ago: 'hace',
    justNow: 'ahora mismo',
    today: 'Hoy',
    yesterday: 'Ayer',
    tomorrow: 'Mañana',
  },
  units: {
    usd: 'USD',
    eur: 'EUR',
    gbp: 'GBP',
    lot: 'lote',
    lots: 'lotes',
    pips: 'pips',
    percent: '%',
  },
  cascade: {
    settingsArchitecture: 'Arquitectura de configuración',
    title: 'Sistema de prioridad en cascada',
    subtitle: 'Las configuraciones se resuelven de mayor a menor prioridad. Deja un campo',
    subtitleNull: 'vacío (NULL)',
    subtitleFallthrough: 'para saltarse esa capa y pasar a la siguiente.',
    resolutionOrder: 'Orden de resolución:',
    firstNonNull: 'El primer valor no nulo gana',
    highestPriority: 'Prioridad más alta — Haz clic en cualquier capa para explorar',
    ifEmptyFallsThrough: '↓ si está vacío, pasa a la siguiente',
    priority: 'Prioridad',
    leaveFieldEmpty: 'Deja cualquier campo vacío (NULL)',
    skipLayer: 'para saltarse esta capa e ir a',
    finalFallback: 'Último recurso — no hay capa inferior.',
    hardLimitsNote: 'Los campos marcados',
    hardLimitsNote2: 'son límites estrictos aplicados a nivel del sistema.',
    layers: {
      userOverride: 'Anulación de usuario',
      userSublabel: 'Acuerdos especiales por cliente',
      userTooltip: 'Máxima prioridad. Cualquier campo aquí supera todo lo demás.',
      userFallsTo: 'Grupo de cuentas (P2)',
      accountGroup: 'Grupo de cuentas',
      groupSublabel: 'Niveles VIP, Estándar, Profesional',
      groupTooltip: 'Aplicado a todos los clientes del grupo.',
      groupFallsTo: 'Configuración del símbolo (P3)',
      symbolSettings: 'Configuración del símbolo',
      symbolSublabel: 'Config del bróker por instrumento',
      symbolTooltip: 'Controla las reglas de precios y ejecución por instrumento.',
      symbolFallsTo: 'Valores predeterminados (P4)',
      platformDefaults: 'Valores predeterminados',
      platformSublabel: 'Respaldo del sistema y límites estrictos',
      platformTooltip: 'Menor prioridad para valores por defecto, pero aplica límites absolutos.',
    },
    setByBroker: 'Establecido por el bróker',
    setBySystemAdmin: 'Establecido por el administrador',
    goToClients: 'Ir a clientes',
    goToAccountGroups: 'Ir a grupos de cuentas',
    goToInstruments: 'Ir a instrumentos',
    fields: {
      maxLeverage: 'Apalancamiento máximo',
      maxLotSize: 'Tamaño máximo de lote',
      marginCallLevel: 'Nivel de llamada de margen',
      stopOutLevel: 'Nivel de stop out',
      maxOpenPositions: 'Posiciones abiertas máximas',
      commissionPerLot: 'Comisión por lote',
      tradingDisabled: 'Trading deshabilitado',
      spreadMarkup: 'Margen del spread',
      swapMarkup: 'Margen del swap',
      tripleSwapDay: 'Día de triple swap',
      stopLevel: 'Nivel de stop',
      freezeLevel: 'Nivel de congelamiento',
      defaultLeverage: 'Apalancamiento predeterminado',
      defaultCommission: 'Comisión predeterminada',
      defaultMarginCall: 'Llamada de margen predeterminada',
      defaultStopOut: 'Stop out predeterminado',
      maxLeverageCap: 'Techo de apalancamiento',
      minMarginCall: 'Llamada de margen mínima',
      minStopOut: 'Stop out mínimo',
      maxCommissionCap: 'Techo de comisión',
      maxPositionsCap: 'Techo de posiciones',
    },
    fieldDescs: {
      capLeverageClient: 'Limitar apalancamiento para este cliente',
      limitPositionSize: 'Limitar tamaño de posición por operación',
      overrideAlertThreshold: 'Anular umbral de alerta',
      overrideAutoClose: 'Anular umbral de cierre automático',
      limitConcurrentTrades: 'Limitar operaciones simultáneas',
      customCommission: 'Tasa de comisión personalizada',
      killSwitch: 'Interruptor de emergencia para este cliente',
      groupCommission: 'Tasa de comisión del grupo',
      groupLeverage: 'Techo de apalancamiento del grupo',
      groupMarginCall: 'Umbral de alerta del grupo',
      groupStopOut: 'Umbral de cierre automático del grupo',
      groupPositions: 'Límite de posiciones del grupo',
      groupLotSize: 'Límite de tamaño del grupo',
      pipsAddedSpread: 'Pips añadidos al spread bruto',
      symbolCommission: 'Comisión específica del símbolo',
      overnightSwap: 'Añadido a las tasas de swap nocturno',
      tripleSwapDay: 'Día en que se cobra el triple swap',
      symbolLeverage: 'Techo de apalancamiento del símbolo',
      symbolLotSize: 'Límite de tamaño del símbolo',
      minSlTpDistance: 'Distancia mínima SL/TP en pips',
      modificationFreeze: 'Distancia de congelamiento de modificación',
      fallbackLeverage: 'Apalancamiento de respaldo',
      fallbackCommission: 'Comisión de respaldo',
      fallbackMarginCall: 'Llamada de margen de respaldo',
      fallbackStopOut: 'Stop out de respaldo',
      hardCeilingLeverage: 'Techo estricto — ninguna capa puede superar',
      hardFloorMarginCall: 'Piso estricto — ninguna capa puede bajar',
      hardFloorStopOut: 'Piso estricto — ninguna capa puede bajar',
      hardCeilingCommission: 'Techo estricto de comisión',
      systemPositionLimit: 'Límite de posiciones del sistema',
    },
  },
  emailTemplates: {
    loadingTemplates: 'Cargando plantillas...',
    loadingTemplate: 'Cargando plantilla...',
    retry: 'Reintentar',
    allTemplates: '← Todas las plantillas',
    customised: 'Personalizado',
    custom: 'Personalizado',
    default: 'Predeterminado',
    subjectLine: 'Línea de asunto',
    subjectPlaceholder: 'Asunto del correo...',
    editorTab: 'Editor',
    htmlTab: 'HTML',
    previewTab: 'Vista previa',
    variables: 'Variables:',
    showLess: 'Mostrar menos',
    clickToInsert: 'Haz clic para insertar variable:',
    saveTemplate: 'Guardar plantilla',
    savingTemplate: 'Guardando...',
    resetToDefault: 'Restablecer predeterminado',
    resetting: 'Restableciendo...',
    back: 'Volver',
    resetConfirm: '¿Restablecer la plantilla premium por defecto? Se perderán tus personalizaciones.',
    subjectBodyRequired: 'El asunto y el cuerpo son obligatorios',
    activeBranding: 'Marca activa',
    companyName: 'Nombre de la empresa',
    primaryColor: 'Color principal',
    logoUrl: 'URL del logo',
    noLogoSet: 'Sin logo configurado',
    emailFooter: 'Pie de correo',
    brandingNote: 'Para actualizar tu marca, ve a Configuración del bróker.',
    editBranding: 'Editar marca',
    closeBranding: 'Cerrar marca',
    templateListDesc: 'Haz clic en una plantilla para editarla.',
    templateInfoNote: 'Las plantillas marcadas como Predeterminado usan el diseño integrado con tu marca.',
    loadingBranding: 'Cargando marca...',
    typeDepositApproved: 'Depósito aprobado',
    typeDepositRejected: 'Depósito rechazado',
    typeWithdrawalApproved: 'Retiro aprobado',
    typeWithdrawalRejected: 'Retiro rechazado',
    typeMarginCall: 'Llamada de margen',
    typeLiquidation: 'Cuenta liquidada',
    typeKycApproved: 'KYC aprobado',
    typeKycRejected: 'KYC rechazado',
    typeWelcome: 'Correo de bienvenida',
  },
  credits: {
    activeRules: 'Reglas activas',
    totalAwarded: 'Total otorgado',
    awardEvents: 'Eventos de otorgamiento',
    bonusRules: 'Reglas de bonificación',
    awardHistory: 'Historial de otorgamiento',
    newRule: 'Nueva regla',
    manualAward: 'Otorgamiento manual',
    noBonusRules: 'Sin reglas de bonificación. Agrega una para comenzar.',
    noCreditAwards: 'Sin otorgamientos de crédito.',
    deactivateConfirm: '¿Desactivar esta regla?',
    revokeReason: 'Motivo de revocación (opcional):',
    operationFailed: 'Operación fallida',
    bonusRuleTitle: 'Regla de bonificación {mode}',
    ruleName: 'Nombre de la regla (ej. Bono de bienvenida)',
    percentOfDeposit: '% del depósito (ej. 20)',
    fixedAmountUsd: 'Monto fijo (USD)',
    maxCreditCap: 'Techo máximo de crédito (opcional)',
    minDepositQualify: 'Depósito mínimo para calificar',
    expiresAfterDays: 'Expira después de N días (opcional)',
    ruleActive: 'Activo — otorgamiento automático en depósitos calificados',
    ruleDisabled: 'Deshabilitado',
    savingDots: 'Guardando...',
    awardingDots: 'Otorgando...',
    manualCreditAward: 'Otorgamiento manual de crédito',
    accountId: 'ID de cuenta',
    userId: 'ID de usuario',
    amountUsd: 'Monto (USD)',
    notesOptional: 'Notas (opcional)',
    awardCredit: 'Otorgar crédito',
    infoWelcomeDeposit: 'Las reglas WELCOME y DEPOSIT se activan automáticamente al aprobar el depósito.',
    bonusWelcome: 'Bienvenida',
    bonusDeposit: 'Depósito',
    bonusGoodwill: 'Buena voluntad',
    bonusPromotion: 'Promoción',
    statusRevoked: 'Revocado',
    statusExpired: 'Expirado',
  },
  pages: {
    websitePages: 'Páginas del sitio web',
    websitePagesDesc: 'Construye y gestiona tu sitio web.',
    pluginNotActive: 'Plugin no activo.',
    viewPlugins: 'Ver plugins',
    mainPages: 'Páginas principales',
    legalPages: 'Páginas legales',
    langs: 'idiomas',
    save: 'Guardar',
    saved: 'Guardado',
    error: 'Error',
    publish: 'Publicar',
    unpublish: 'Despublicar',
    published: 'Publicado',
    draft: 'Borrador',
    tabBlocks: 'Bloques',
    tabSeo: 'SEO',
    addBlock: 'Agregar bloque',
    addFirstBlock: 'Agregar primer bloque',
    addFirstBlockHint: 'Agrega tu primer bloque de contenido',
    noBlocks: 'Sin bloques',
    pageTitle: 'Título de la página',
    pageTitleHint: 'Título principal mostrado en la navegación',
    translatable: 'Traducible',
    pageSlug: 'Slug de la página',
    seoTitle: 'Título SEO',
    seoDescription: 'Descripción SEO',
    googlePreview: 'VISTA PREVIA DE GOOGLE',
    noDescription: 'Sin descripción.',
    catHeroLayout: 'Hero y diseño',
    catContent: 'Contenido',
    catFeaturesData: 'Características y datos',
    catSocialProof: 'Prueba social',
    catCta: 'Llamada a la acción',
    catDocuments: 'Documentos y legal',
    catOther: 'Otro',
    missing: 'Faltante',
    add: 'Agregar',
    addItem: 'Agregar elemento',
    item: 'Elemento',
    notStarted: 'No iniciado',
  },
  userOverride: {
    title: 'Anulación de cuenta de usuario',
    infoBannerTitle: 'Anulaciones a nivel de usuario (Capa 1)',
    infoBannerDesc: 'Estas configuraciones anulan los valores predeterminados del grupo. Deja vacío (NULL) para usar la configuración del grupo.',
    sectionTradingControl: 'Control de trading',
    sectionRiskParameters: 'Parámetros de riesgo',
    sectionPricingOverrides: 'Anulaciones de precios',
    disableTrading: 'Deshabilitar trading',
    disableTradingSubLabel: 'Impedir que este usuario abra nuevas posiciones',
    resetToGroupDefault: 'Restablecer predeterminado del grupo',
    groupDefault: 'Predeterminado del grupo',
    maxLeverage: 'Apalancamiento máximo',
    maxLotSize: 'Tamaño máximo de lote',
    minLotSize: 'Tamaño mínimo de lote',
    marginCallLevel: 'Nivel de llamada de margen (%)',
    stopOutLevel: 'Nivel de stop out (%)',
    maxOpenPositions: 'Posiciones abiertas máximas',
    commissionPerLot: 'Comisión por lote (USD)',
    commissionPerLotHint: 'USD cobrado por lote estándar operado',
    minAboveMaxError: '⚠️ El tamaño mínimo no puede superar el máximo',
    currentOverrideTitle: 'Anulación activa',
    currentOverrideDesc: 'Este usuario tiene configuraciones personalizadas que anulan los valores del grupo.',
    saveOverride: 'Guardar anulación',
    saving: 'Guardando...',
    saveSuccess: 'Anulación de usuario guardada correctamente',
    saveFailed: 'Error al guardar la anulación',
    lots: 'lotes',
    lotStep: 'Paso de lote',
  },
  symbolSettings: {
    sectionPricing: 'Precios del bróker',
    sectionRisk: 'Límites de riesgo',
    sectionExecution: 'Reglas de ejecución',
    sectionOverrides: 'Anulaciones de instrumento',
    sectionsLabel: 'Secciones',
    pricingDesc: 'Ajustes aplicados sobre las tasas brutas del instrumento.',
    riskDesc: 'Límites de posición y apalancamiento a nivel del bróker.',
    executionDesc: 'Restricciones de colocación y modificación de órdenes.',
    overridesDesc: 'Activa cada campo para una anulación a nivel del bróker.',
    overridesInfoTitle: 'Swap Long / Swap Short',
    overridesInfoDesc: 'Reemplaza completamente la tasa del instrumento cuando está activado.',
    settingsTitle: 'Configuración de {symbol}',
    headerSubtitle: 'Configurar precios y riesgo a nivel del bróker (Capa 3)',
    overrideActive: '{count} anulación activa',
    overridesActive: '{count} anulaciones activas',
    spreadMarkup: 'Margen del spread',
    spreadMarkupHint: 'Pips añadidos al spread bruto del proveedor de liquidez',
    commissionPerLot: 'Comisión por lote',
    commissionPerLotHint: 'USD cobrado por lote estándar operado',
    swapMarkup: 'Margen del swap',
    swapMarkupHint: 'Puntos añadidos a las tasas de swap del instrumento.',
    tripleSwapDay: 'Día de triple swap',
    tripleSwapDayHint: 'Día en que se cobra el triple swap',
    maxLeverage: 'Apalancamiento máximo',
    maxLeverageHint: 'Apalancamiento máximo permitido para este símbolo',
    maxLotSize: 'Tamaño máximo de lote',
    maxLotSizeHint: 'Tamaño máximo de posición por operación',
    minLotSize: 'Tamaño mínimo de lote',
    minLotSizeHint: 'Tamaño mínimo de posición por operación',
    minAboveMaxError: '⚠️ El tamaño mínimo no puede superar el máximo',
    stopLevel: 'Nivel de stop',
    stopLevelHint: 'Distancia mínima SL/TP desde el precio de mercado (pips)',
    freezeLevel: 'Nivel de congelamiento',
    freezeLevelHint: 'Distancia a la que se congelan las modificaciones de órdenes (pips)',
    contractSize: 'Tamaño del contrato',
    contractSizeHint: 'Unidades por lote.',
    priceScale: 'Escala de precio',
    priceScaleHint: 'Decimales para la cotización.',
    swapLong: 'Swap Long (tasa directa)',
    swapLongHint: 'Tasa nocturna para posiciones COMPRA.',
    swapShort: 'Swap Short (tasa directa)',
    swapShortHint: 'Tasa nocturna para posiciones VENTA.',
    swapMode: 'Modo swap',
    swapModeHint: 'Cómo se calcula la tasa de swap nocturno',
    maxVolume: 'Volumen máximo (lotes)',
    maxVolumeHint: 'Tamaño máximo de una sola operación en lotes.',
    volumeStep: 'Paso de volumen (lotes)',
    volumeStepHint: 'Incremento mínimo de tamaño de operación.',
    defaultBadge: 'predeterminado',
    pips: 'pips',
    pts: 'pts',
    lots: 'lotes',
    decimals: 'decimales',
    dayMon: 'Lun',
    dayTue: 'Mar',
    dayWed: 'Mié',
    dayThu: 'Jue',
    dayFri: 'Vie',
    daySat: 'Sáb',
    daySun: 'Dom',
    loadingSettings: 'Cargando configuración...',
    saveSettings: 'Guardar configuración',
    lotStep: 'Paso de lote',
  },
  accountGroupForm: {
    sectionsLabel: 'Secciones',
    sectionBasic: 'Información básica',
    sectionPricing: 'Anulaciones de precios',
    sectionRisk: 'Gestión de riesgos',
    editTitle: 'Editar grupo de cuentas',
    createTitle: 'Crear grupo de cuentas',
    basicInfoTitle: 'Información básica',
    groupNameLabel: 'Nombre del grupo *',
    groupNamePlaceholder: 'Grupo Estándar',
    descriptionLabel: 'Descripción',
    descriptionPlaceholder: 'Descripción del grupo...',
    groupActive: 'Grupo activo',
    defaultGroup: 'Grupo predeterminado',
    pricingTitle: 'Anulaciones de precios',
    pricingDesc: 'Deja vacío para usar los valores del bróker.',
    commissionPerLot: 'Comisión por lote (USD)',
    commissionPerLotHint: 'USD cobrado por lote estándar operado',
    maxLeverage: 'Apalancamiento máximo',
    maxLeverageHint: 'Apalancamiento máximo disponible para este grupo',
    brokerDefault: 'Predeterminado del bróker',
    resetToNoLimit: 'Restablecer sin límite',
    riskTitle: 'Gestión de riesgos',
    marginCallLevel: 'Nivel de llamada de margen',
    marginCallHint: 'Alerta cuando el nivel de margen alcanza este porcentaje',
    stopOutLevel: 'Nivel de stop out',
    stopOutHint: 'Cierre automático de posiciones a este nivel de margen',
    maxOpenPositions: 'Posiciones abiertas máximas',
    maxOpenPositionsHint: 'Número máximo de posiciones por cuenta',
    maxLotSize: 'Tamaño máximo de lote',
    maxLotSizeHint: 'Tamaño máximo de lote por operación',
    minLotSize: 'Tamaño mínimo de lote',
    minLotSizeHint: 'Tamaño mínimo de lote para este grupo',
    noLimit: 'Sin límite',
    lots: 'lotes',
    marginBelowStopError: '⚠️ La llamada de margen debe ser mayor que el stop out',
    minAboveMaxError: '⚠️ El tamaño mínimo no puede superar el máximo',
    updateGroup: 'Actualizar grupo',
    createGroup: 'Crear grupo',
    lotStep: 'Paso de lote',
  },
  cryptoCheckout: {
    paymentConfirmedTitle: '¡Pago confirmado!',
    makePayment: 'Realizar pago',
    depositFunds: 'Depositar fondos',
    purchaseItem: 'Comprar {name}',
    subscribeTo: 'Suscribirse a {name}',
    selectPaymentMethod: 'Seleccionar método de pago',
    payWith: 'Pagar con {currencies}',
    creatingPayment: 'Creando pago...',
    continue: 'Continuar',
    sendExactly: 'Enviar exactamente',
    approxUsd: '≈ ${amount} USD',
    hideQrCode: 'Ocultar código QR',
    showQrCode: 'Mostrar código QR',
    scanWithWallet: 'Escanea con tu monedero móvil',
    toThisAddress: 'A esta dirección {network}',
    expiresIn: 'Expira en',
    waitingForPayment: 'Esperando pago...',
    waitingDesc: 'Envía el monto exacto. Lo detectaremos automáticamente.',
    verifiedOnChain: 'Verificado en cadena por AmorPay.',
    pluginActivated: '{name} ha sido activado.',
    depositCredited: 'Tu depósito ha sido acreditado a tu cuenta.',
    subscriptionActive: 'Tu suscripción está activa.',
    paymentConfirmed: 'Tu pago ha sido confirmado.',
    done: 'Listo',
    noItemSelected: 'Ningún artículo seleccionado',
    failedToLoadOptions: 'Error al cargar opciones de pago',
  },
  subscriptionGate: {
    accountSuspended: 'Cuenta suspendida',
    subscriptionExpired: 'Suscripción expirada',
    suspendedDesc: 'Tu cuenta ha sido suspendida. Contacta soporte.',
    expiredDesc: 'Tu suscripción {plan} ha expirado. Renueva para restaurar el acceso.',
    renewSubscription: 'Renovar suscripción',
    signOut: 'Cerrar sesión',
    needHelp: '¿Necesitas ayuda? Contacta',
    lastChance: '⚠️ ¡Última oportunidad! Tu suscripción {plan} expiró. El acceso termina hoy.',
    gracePeriodDay: 'Tu suscripción {plan} ha expirado. Te queda {days} día.',
    gracePeriodDays: 'Tu suscripción {plan} ha expirado. Te quedan {days} días.',
    renewNow: 'Renovar ahora',
  },
  upgradePage: {
    renewTitle: 'Renovar suscripción',
    upgradeTitle: 'Actualizar tu plan',
    currentlyOn: 'Actualmente en',
    graceDaysLeft: '{days} día restante',
    graceDaysLeftPlural: '{days} días restantes',
    expired: 'Expirado',
    graceWarning: 'Tu suscripción expiró. Tienes {days} día para renovar antes de que se bloquee tu cuenta.',
    graceWarningPlural: 'Tu suscripción expiró. Tienes {days} días para renovar.',
    expiredWarning: 'Tu suscripción ha expirado completamente. Renueva ahora.',
    renewOrUpgrade: 'Renueva tu plan actual o actualiza a un nivel superior.',
    monthly: 'Mensual',
    yearly: 'Anual',
    mostPopular: 'Más popular',
    currentPlan: 'Plan actual',
    perMonth: '/mes',
    saveYearly: 'Ahorra 10% — facturado ${amount}/año',
    unlimitedTraders: 'Traders ilimitados',
    tradersCount: '{count} traders',
    unlimitedAdmins: 'Admins ilimitados',
    adminsCount: '{count} admins',
    unlimitedInstruments: 'Instrumentos ilimitados',
    instrumentsCount: '{count} instrumentos',
    feedUltra: 'Feed de ultra baja latencia',
    feedPriority: 'Feed prioritario',
    feedStandard: 'Feed estándar',
    fullApiAccess: 'Acceso API completo',
    selected: 'Seleccionado',
    selectPlan: 'Seleccionar plan',
    fullComparison: 'Comparación completa',
    featureCol: 'Característica',
    featureTraders: 'Traders',
    featureAdmins: 'Admins',
    featureInstruments: 'Instrumentos',
    featureFeedLatency: 'Latencia del feed',
    featureApiAccess: 'Acceso API',
    featureForex: 'Forex',
    featureCrypto: 'Cripto',
    featureCommodities: 'Materias primas',
    featureIndices: 'Índices',
    featureStocks: 'Acciones',
    selectedPlan: 'Plan seleccionado:',
    selectToContinue: 'Selecciona un plan para continuar',
    perYear: '/año',
    renewNow: 'Renovar ahora',
    upgradeNow: 'Actualizar ahora',
    failedToLoadPlans: 'Error al cargar los planes',
    selectPlanFirst: 'Por favor selecciona un plan primero',
    planActivated: '¡Plan {name} activado! 🎉',
  },

  sidebar: {
    sectionOverview: 'Resumen',
    sectionManagement: 'Gestión',
    sectionTrading: 'Trading',
    sectionFinance: 'Finanzas',
    sectionPlugins: 'Plugins',
    sectionSystem: 'Sistema',
    accountGroups: 'Grupos de cuentas',
    cascadeGuide: 'Guía en cascada',
    pluginStore: 'Tienda de plugins',
    kycVerification: 'Verificación KYC',
    kycDashboard: 'Panel KYC',
    kycConfig: 'Config KYC',
    pages: 'Páginas',
    credits: 'Créditos',
    emailTemplates: 'Plantillas de correo',
    restApi: 'REST API',
    advancedAnalytics: 'Analítica avanzada',
    descClients: 'Usuarios · Configuración · Anulaciones',
    descGroups: 'Grupos · Configuración · Anulaciones',
    descInstruments: 'Broker · Configuración · Anulaciones',
    descAccounts: 'Cuentas y saldos',
    descCascade: 'Sistema de prioridades explicado',
    descAnalytics: 'Información impulsada por IA',
    badgeLive: 'En vivo',
    badgeActive: 'Activo',
    badgeAddon: 'Complemento',
    badgePro: 'PRO',
    badgeApi: 'API',
    badgeConfig: 'Config',
    badgeHowItWorks: 'Cómo funciona',
    cascadeTipFallthrough: 'Deje los campos vacíos para pasar a la siguiente capa',
  },

};